import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FunctionComponent, ReactElement } from 'react';

interface LevelRemoveConfirmationProps {
	open: boolean;
	onClose: () => void;
	onConfirm: (id: string) => void;
	level?: { id?: string; name: string };
}

const LevelRemoveConfirmation: FunctionComponent<LevelRemoveConfirmationProps> = ({
	open,
	onClose,
	onConfirm,
	level,
}): ReactElement => (
	<Dialog open={open} onClose={onClose} maxWidth="xs">
		<DialogTitle>Remove location</DialogTitle>
		<DialogContent>
			{level &&
				`Are you sure you wish to remove location level ${level.name}? This action will remove all subsequent levels, and once saved, cannot be undone.`}
		</DialogContent>
		<DialogActions>
			<Button onClick={onClose}>Cancel</Button>
			<Button
				onClick={() => {
					if (level?.id) onConfirm(level.id);
					onClose();
				}}
				variant="contained"
			>
				Remove Location
			</Button>
		</DialogActions>
	</Dialog>
);

export default LevelRemoveConfirmation;
